export default {
  VIEW: 'view',
  MODIFY: 'modify',
  CREATE: 'create',
  DELETE: 'delete',
  MODIFY_CATEGORIES: 'modifyCategories',
  CAN_EDIT_RESTRICTED_FIELDS: 'canEditRestrictedFields',
  MULTIPLE_CLIENT_MANAGEMENT: 'multipleClientManagement',
};
